import SoftSkills from './SoftSkills'
export default SoftSkills
